export const cars =[
    {
        image: "/images/Renault_daster/1.jpg",
        // title: "Renault Daster"
    },
    {
        image: "/images/Renault_daster/2.jpg",
        // title: "Renault Daster"
    },
    {
        image: "/images/Renault_daster/3.jpg",
        // title: "Renault Daster"
    },
    {
        image: "/images/Renault_daster/4.jpg",
        // title: "Renault Daster"
    },
    {
        image: "/images/Renault_daster/5.jpg",
        // title: "Renault Daster"
    }
];